import { render, staticRenderFns } from "./MatchColumns.vue?vue&type=template&id=5ef315da&scoped=true&"
import script from "./MatchColumns.vue?vue&type=script&lang=js&"
export * from "./MatchColumns.vue?vue&type=script&lang=js&"
import style0 from "./MatchColumns.vue?vue&type=style&index=0&id=5ef315da&lang=scss&scoped=true&"
import style1 from "./MatchColumns.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef315da",
  null
  
)

export default component.exports